module.exports = {"513429100":"特木里镇","513429101":"龙潭镇","513429102":"拖觉镇","513429103":"九都镇","513429104":"乐安镇","513429105":"俄里坪镇","513429106":"地洛镇","513429107":"牛角湾镇","513429206":"补尔乡","513429209":"拉果乡","513429224":"委只洛乡","513429226":"基只乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513429.json
// module id = 2570
// module chunks = 0